import { Link } from "react-router-dom";
import { requestOpenCookieSettings } from "../utils/cookieConsent";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="footer"
      style={{
        borderTop: "1px solid #222",
        padding: "32px 16px",
        background: "#121212",
        color: "#ccc",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "24px",
          marginBottom: "12px",
        }}
      >
        <Link to="/terms" style={{ color: "#ccc", textDecoration: "none" }}>
          Términos
        </Link>
        <Link to="/privacy" style={{ color: "#ccc", textDecoration: "none" }}>
          Privacidad
        </Link>
        <Link to="/cookies" style={{ color: "#ccc", textDecoration: "none" }}>
          Cookies
        </Link>
        <button
          type="button"
          onClick={requestOpenCookieSettings}
          style={{
            color: "#ccc",
            background: "transparent",
            border: "none",
            padding: 0,
            cursor: "pointer",
            textDecoration: "underline",
            font: "inherit",
          }}
        >
          Gestionar cookies
        </button>
        <Link to="/terms#fuentes-datos" style={{ color: "#ccc", textDecoration: "none" }}>
          Fuentes de datos
        </Link>
        <Link to="/contact" style={{ color: "#ccc", textDecoration: "none" }}>
          Contacto
        </Link>
      </div>

      <div style={{ textAlign: "center", color: "#8e9aac", fontSize: "0.86rem", marginBottom: 10 }}>
        Datos de catálogo e imágenes: IGDB. Noticias: Steam y medios enlazados.
      </div>

      <div
        style={{
          textAlign: "center",
          borderTop: "1px solid #222",
          paddingTop: "12px",
          color: "#888",
          fontSize: "0.9rem",
        }}
      >
        © XPHub {currentYear}
      </div>
    </footer>
  );
}

export default Footer;
